export default "__VITE_ASSET__FzkGrlK9__"